/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { setIsDmaStorage } from 'utils/storage'
import { DRAWER_KEY } from 'app-constants'

const initialState = {
  key: '',
  stage: 'initial',
  history: [],
  alert: null,
  onClose: null,
  modal: null,
  headerVisibility: true,
  allowCloseOnReturnButton: false,
  data: {},
}

function updateDrawer(state, action) {
  state.key = action.payload
  state.stage = 'initial'
  state.history = []
  state.alert = null
  state.onClose = null
  state.headerVisibility = true
  state.allowCloseOnReturnButton = false
  state.modal = null

  if (action.payload === '') setIsDmaStorage(false)
}

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setDrawer: updateDrawer,
    setData: (state, action) => {
      state.data = action.payload
    },
    setStage: (state, action) => {
      state.history.push(state.stage)
      state.stage = action.payload
    },
    setOnClose: (state, action) => {
      state.onClose = action.payload
    },
    goBack: state => {
      const stage = state.history.pop()
      if (stage) {
        state.stage = stage
      } else {
        updateDrawer(state, { payload: DRAWER_KEY.NONE })
      }
    },
    clearHistory: state => {
      state.history = []
    },
    clearDrawerAlert: state => {
      state.alert = null
    },
    setDrawerAlert: (state, action) => {
      state.alert = action.payload
    },
    setDrawerModal: (state, action) => {
      state.modal = action.payload
    },
    clearDrawerModal: state => {
      state.modal = null
    },
    setHeaderVisibility: (state, action) => {
      state.headerVisibility = action.payload
    },
    setAllowCloseOnReturnButton: (state, action) => {
      state.allowCloseOnReturnButton = action.payload
    },
  },
})

export const {
  setDrawer,
  setStage,
  setOnClose,
  goBack,
  clearHistory,
  clearDrawerAlert,
  setDrawerAlert,
  setDrawerModal,
  clearDrawerModal,
  setHeaderVisibility,
  setAllowCloseOnReturnButton,
  setData,
} = drawerSlice.actions

export default drawerSlice.reducer
